module.exports = __webpack_public_path__ + "assets/images/piramide-do-egito_25123b0b045c22160f3b5c00c7441202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/piramide/piramide-do-egito.png
// module id = 212
// module chunks = 0